import React from "react";
import WaveText from "../WaveText";

export default function CreateDialogueGeneratorPanel({
  showCreateDialogueGenerator, generatedCreateDialogue, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showEssentialVocabularyGenerator, showLeadInActivitiesGenerator,
  showFourOpinionsGenerator, showCommunicativeSituationsGenerator, showGrammarRulesGenerator,
  createDialogueInput, setCreateDialogueInput, createDialogueLevel, setCreateDialogueLevel,
  createDialogueSpeakers, setCreateDialogueSpeakers, createDialogueLoading,
  handleCreateDialogueGenerate, handleCreateDialogueInsert, handleCreateDialogueCancel,
}) {
  if (!((showCreateDialogueGenerator || generatedCreateDialogue) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleCreateDialogueCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Create a Dialogue on Any Topic</span>
      </div>

      <textarea
        value={createDialogueInput}
        onChange={e => setCreateDialogueInput(e.target.value)}
        placeholder="Enter a topic or target vocabulary for the dialogue..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          CEFR Level:
          <select
            value={createDialogueLevel}
            onChange={e => setCreateDialogueLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer',
              width: 100
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 6 }}>
          Speakers:
          <input
            type="number"
            min={1}
            max={6}
            value={createDialogueSpeakers}
            onChange={e => setCreateDialogueSpeakers(e.target.value)}
            onBlur={e => setCreateDialogueSpeakers(Math.max(1, Math.min(6, Number(e.target.value) || 1)))}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              width: 60
            }}
          />
        </label>
      </div>

      <button
        onClick={handleCreateDialogueGenerate}
        disabled={createDialogueLoading || !createDialogueInput.trim()}
        className={createDialogueLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: createDialogueLoading || !createDialogueInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: createDialogueLoading || !createDialogueInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: createDialogueLoading || !createDialogueInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {createDialogueLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedCreateDialogue && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Create a Dialogue on Any Topic
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            Topic: {generatedCreateDialogue.topic}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleCreateDialogueInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
